import { render, staticRenderFns } from "./WebhookConfig.vue?vue&type=template&id=d2e32e0a&scoped=true"
import script from "./WebhookConfig.vue?vue&type=script&lang=js"
export * from "./WebhookConfig.vue?vue&type=script&lang=js"
import style0 from "./WebhookConfig.vue?vue&type=style&index=0&id=d2e32e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e32e0a",
  null
  
)

export default component.exports